import React from 'react';
import autoBind from 'react-autobind';
import { withTheme } from '@material-ui/core/styles';

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"
import LocaleOverviewStageElement from "../../views/locale/LocaleOverviewStageElement.jsx"

import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Icon,
  Divider,
  Typography
} from '@material-ui/core';
import Helper from "../../Helper.jsx";

class LocaleOverviewStage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  stagePreview() {
    if (this.props.stageData.movie_list != null && this.props.stageData.movie_list.length > 0) {
      return (
        <img
          style={{maxHeight:"100%", maxWidth:"100%", display:"block", margin:"auto", borderRadius:4}}
          src={Config.BASE_PATH() + this.props.stageData.movie_list[0].tn_path}
        />
      )
    }
  }

  playbackItem(playbackData) {
    return (
      <ListItem 
        key={playbackData.id} 
        alignItems="flex-start"
        style={{
          marginBottom: '8px',
          backgroundColor: this.props.theme.palette.background.paper,
          borderRadius: '8px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = this.props.theme.palette.action.hover;
          e.currentTarget.style.transform = 'translateX(4px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = this.props.theme.palette.background.paper;
          e.currentTarget.style.transform = 'translateX(0)';
        }}
      >
        <ListItemAvatar>
          <Icon style={{
            color: this.props.theme.palette.primary.main,
            backgroundColor: this.props.theme.palette.primary.light + '20',
            padding: '8px',
            borderRadius: '50%'
          }}>
            {Config.GET_PLAYBACK_CONFIG(parseInt(playbackData.kind))['icon']}
          </Icon>
        </ListItemAvatar>
        <ListItemText style={{
          margin: '4px 0'
        }}>
          <LocaleOverviewStageElement root={this.props.root} parent={this} playbackData={playbackData}/>
        </ListItemText>
      </ListItem>
    )
  }

  render() {
    return (
      <div>
        <Divider variant="middle"/>
        <Card style={{margin:"0 0 16px 0"}} elevation={0}>
          <CardHeader
            title={
              <div style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 0',
                borderBottom: `2px solid ${this.props.theme.palette.primary.main}`,
                marginBottom: '8px'
              }}>
                <Typography variant="h6" style={{
                  fontWeight: 600,
                  color: this.props.theme.palette.primary.main,
                  flex: 1
                }}>
                  {this.props.stageData.stage_name}
                </Typography>
                <Typography variant="subtitle1" style={{
                  color: '#757575',
                  fontWeight: 500
                }}>
                  {Helper.fToHHMMSS(this.props.stageData.duration)}
                </Typography>
              </div>
            }
          />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                {this.stagePreview()}
              </Grid>
              <Grid item xs={12} sm={6}>
                <List style={{
                  // backgroundColor: '#fafafa',
                  borderRadius: '8px',
                  padding: '8px'
                }}>
                  {this.props.stageData.playback_list.map((row, i) => {
                    return (
                      this.playbackItem(row)
                    );
                  })}
                </List>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default withTheme(LocaleOverviewStage);
